import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateServiceImage = async (placeId, serviceId, file) => {
  if (!placeId || !serviceId || !file) {
    console.log('NO PLACE ID');
    return;
  }
  let data = new FormData();
  data.append('file', file);

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/services/${serviceId}/update/image`,
    data,
  });
};